import React, { useState } from 'react';
import { ArrowLeft, Heart, Shield, User, MapPin, FileText, Zap, Building, DollarSign, Download, CheckCircle, AlertTriangle, Clock, Calculator } from 'lucide-react';
import { Link, useParams } from 'react-router-dom';
import { TrustBadge } from '../components/TrustBadge';
import { DocumentSection } from '../components/DocumentSection';
import { SocialShare } from '../components/SocialShare';
import { ContactSellerModal } from '../components/modals/ContactSellerModal';
import { ScheduleVisitModal } from '../components/modals/ScheduleVisitModal';
import { MessageModal } from '../components/modals/MessageModal';
import { ReviewsSection } from '../components/ReviewsSection';
import { QASection } from '../components/QASection';
import { Footer } from '../components/Footer';
export function ListingDetailPage() {
  const {
    id
  } = useParams();
  const [activeTab, setActiveTab] = useState('overview');
  const [isContactOpen, setIsContactOpen] = useState(false);
  const [isScheduleOpen, setIsScheduleOpen] = useState(false);
  const [isFavorited, setIsFavorited] = useState(false);
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  const listingTitle = 'Premium Corner Plot in Hinjewadi Phase 1';
  const sellerName = 'Rajesh Kumar';
  const handleDownloadAll = () => {
    setIsMessageModalOpen(true);
  };
  const handleFavorite = () => {
    setIsFavorited(!isFavorited);
  };
  // Mock reviews data
  const mockReviews = [{
    id: '1',
    userName: 'Amit Sharma',
    userInitials: 'AS',
    rating: 5,
    date: '2024-01-15',
    verifiedTransaction: true,
    reviewText: 'Excellent property with clear documentation. The seller was very cooperative and transparent throughout the process. All documents were verified and genuine. Highly recommend!',
    sellerResponse: {
      text: 'Thank you for your kind words! It was a pleasure working with you.',
      date: '2024-01-16'
    },
    helpful: 12
  }, {
    id: '2',
    userName: 'Priya Patel',
    userInitials: 'PP',
    rating: 4,
    date: '2024-01-10',
    verifiedTransaction: true,
    reviewText: 'Good location and fair pricing. The plot is exactly as described. Only minor issue was some delay in getting the NA order copy, but overall satisfied with the purchase.',
    helpful: 8
  }, {
    id: '3',
    userName: 'Rohan Gupta',
    userInitials: 'RG',
    rating: 5,
    date: '2024-01-05',
    verifiedTransaction: false,
    reviewText: 'Great investment opportunity! The area is developing rapidly. Metro station coming up nearby will increase property value significantly.',
    helpful: 15
  }];
  // Mock Q&A data
  const mockQuestions = [{
    id: '1',
    userName: 'Priya Patel',
    userInitials: 'PP',
    question: 'Is the price negotiable? What is your best offer?',
    questionDate: '2024-01-10',
    answer: {
      text: 'Slight negotiation is possible for immediate closure. We are looking for a direct buyer without broker involvement. Please contact me to discuss.',
      date: '2024-01-11',
      sellerName: 'Rajesh Kumar'
    }
  }, {
    id: '2',
    userName: 'Amit Kumar',
    userInitials: 'AK',
    question: 'Is home loan available for this property? Which banks have approved it?',
    questionDate: '2024-01-08',
    answer: {
      text: 'Yes, the property is approved by SBI, HDFC, and ICICI Bank for home loans. All necessary documents for loan processing are available.',
      date: '2024-01-09',
      sellerName: 'Rajesh Kumar'
    }
  }, {
    id: '3',
    userName: 'Neha Singh',
    userInitials: 'NS',
    question: 'What is the current status of electricity and water connections?',
    questionDate: '2024-01-12',
    answer: {
      text: 'Electricity connection is already available at the plot boundary. Water connection from municipal corporation is available. Additionally, there is a functional borewell on the property.',
      date: '2024-01-12',
      sellerName: 'Rajesh Kumar'
    }
  }, {
    id: '4',
    userName: 'Vikram Desai',
    userInitials: 'VD',
    question: 'Are there any pending dues or legal issues with this property?',
    questionDate: '2024-01-14',
    answer: {
      text: 'No pending dues whatsoever. Property tax is paid up to date. Legal clearance certificate and encumbrance certificate for 30 years are available. No litigation history.',
      date: '2024-01-14',
      sellerName: 'Rajesh Kumar'
    }
  }];
  const tabs = [{
    id: 'overview',
    label: 'Overview',
    icon: FileText
  }, {
    id: 'location',
    label: 'Location',
    icon: MapPin
  }, {
    id: 'legal',
    label: 'Legal & Title',
    icon: Shield
  }, {
    id: 'infra',
    label: 'Infrastructure',
    icon: Zap
  }, {
    id: 'zoning',
    label: 'Zoning',
    icon: Building
  }, {
    id: 'financials',
    label: 'Financials',
    icon: DollarSign
  }, {
    id: 'documents',
    label: 'Documents',
    icon: FileText
  }, {
    id: 'reviews',
    label: 'Reviews',
    icon: FileText
  }, {
    id: 'qa',
    label: 'Q&A',
    icon: FileText
  }];
  return <div data-testid="listing-detail-page" className="min-h-screen bg-[#f5f5f7] font-sans text-[#1f2933] flex flex-col" data-id="element-4593">
      {/* Header Navigation */}
      <header data-testid="listing-detail-header" className="bg-white border-b border-gray-300 py-4 px-6 md:px-12 sticky top-0 z-20" data-id="element-4594">
        <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-4595">
          <Link data-testid="listing-detail-logo-link" to="/" className="flex items-center gap-2" data-id="element-4596">
            <div className="w-8 h-8 bg-[#1f2933] rounded-sm" data-id="element-4597"></div>
            <span className="font-bold text-xl tracking-tight" data-id="element-4598">
              Citiplots.com
            </span>
          </Link>
          <nav data-testid="listing-detail-nav" className="hidden md:flex gap-8 text-sm font-medium text-gray-600" data-id="element-4599">
            <Link data-testid="listing-detail-nav-buy" to="/" data-id="element-4600">
              Buy Plots
            </Link>
            <Link data-testid="listing-detail-nav-sell" to="/create-listing" data-id="element-4601">
              Sell Land
            </Link>
            <Link data-testid="listing-detail-nav-legal" to="/legal-guides" data-id="element-4602">
              Legal Guides
            </Link>
            <Link data-testid="listing-detail-nav-advocacy" to="/advocacy" data-id="element-4603">
              Advocacy
            </Link>
          </nav>
          <div className="flex gap-4" data-id="element-4604">
            <SocialShare url={window.location.href} title={listingTitle} description="2400 sq ft corner plot with clear title in Hinjewadi" data-id="element-4605" />
            <button data-testid="listing-detail-favorite-btn" onClick={handleFavorite} className={`p-2 border border-gray-300 rounded hover:bg-gray-50 ${isFavorited ? 'bg-red-50 border-red-300' : ''}`} data-id="element-4606">
              <Heart className={`w-4 h-4 ${isFavorited ? 'text-red-600 fill-red-600' : 'text-gray-600'}`} data-id="element-4607" />
            </button>
          </div>
        </div>
      </header>

      <main data-testid="listing-detail-main" className="flex-1 max-w-7xl mx-auto px-4 md:px-6 py-8" data-id="element-4608">
        {/* Breadcrumb */}
        <div data-testid="listing-detail-breadcrumb" className="mb-4" data-id="element-4609">
          <Link data-testid="listing-detail-breadcrumb-home" to="/" className="text-sm text-gray-600 hover:text-gray-900" data-id="element-4610">
            Home
          </Link>
          <span className="text-sm text-gray-400 mx-2" data-id="element-4611">/</span>
          <Link data-testid="listing-detail-breadcrumb-listings" to="/" className="text-sm text-gray-600 hover:text-gray-900" data-id="element-4612">
            Listings
          </Link>
          <span className="text-sm text-gray-400 mx-2" data-id="element-4613">/</span>
          <span data-testid="listing-detail-breadcrumb-current" className="text-sm text-gray-900" data-id="element-4614">
            {listingTitle}
          </span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8" data-id="element-4615">
          {/* Main Content Column */}
          <div className="lg:col-span-8 space-y-6" data-id="element-4616">
            {/* Title Section */}
            <div data-testid="listing-detail-title-section" className="bg-white border border-gray-300 p-6 md:p-8" data-id="element-4617">
              <div className="flex flex-col md:flex-row justify-between items-start gap-4 mb-6" data-id="element-4618">
                <div data-id="element-4619">
                  <div className="flex items-center gap-3 mb-2" data-id="element-4620">
                    <TrustBadge level="verified" data-id="element-4621" />
                    <span data-testid="listing-detail-id" className="text-xs font-mono text-gray-500 uppercase" data-id="element-4622">
                      ID: CP-{id || '2491'}
                    </span>
                    <span data-testid="listing-detail-badge" className="px-2 py-0.5 bg-blue-100 text-blue-800 text-[10px] font-bold uppercase rounded border border-blue-200" data-id="element-4623">
                      New to Market
                    </span>
                  </div>
                  <h1 data-testid="listing-detail-title" className="text-3xl font-bold text-[#1f2933] mb-2" data-id="element-4624">
                    {listingTitle}
                  </h1>
                  <p data-testid="listing-detail-location" className="text-gray-500 font-mono flex items-center gap-2" data-id="element-4625">
                    <MapPin className="w-4 h-4" data-id="element-4626" /> Sector 4, Hinjewadi, Pune,
                    Maharashtra 411057
                  </p>
                </div>
                <div className="text-right" data-id="element-4627">
                  <div data-testid="listing-detail-price" className="text-3xl font-bold text-[#1f2933]" data-id="element-4628">
                    ₹ 45 Lakhs
                  </div>
                  <div data-testid="listing-detail-price-per-sqft" className="text-sm text-gray-500 font-mono" data-id="element-4629">
                    ₹ 1,875 / sq.ft
                  </div>
                </div>
              </div>

              {/* Image Gallery */}
              <div data-testid="listing-detail-gallery" className="grid grid-cols-4 gap-4 aspect-[2/1]" data-id="element-4630">
                <div data-testid="listing-detail-main-image" className="col-span-4 md:col-span-3 bg-gray-100 border-2 border-dashed border-gray-300 flex items-center justify-center text-gray-400 font-mono h-full relative group cursor-pointer hover:bg-gray-200 transition-colors" data-id="element-4631">
                  [Main Plot View]
                  <div className="absolute bottom-4 right-4 bg-black/70 text-white text-xs px-2 py-1 rounded font-bold" data-id="element-4632">
                    1/12 Photos
                  </div>
                </div>
                <div className="hidden md:flex flex-col gap-4 h-full" data-id="element-4633">
                  <div data-testid="listing-detail-map-view" className="flex-1 bg-gray-100 border-2 border-dashed border-gray-300 flex items-center justify-center text-xs text-gray-400 font-mono cursor-pointer hover:bg-gray-200" data-id="element-4634">
                    [Map View]
                  </div>
                  <div data-testid="listing-detail-drone-view" className="flex-1 bg-gray-100 border-2 border-dashed border-gray-300 flex items-center justify-center text-xs text-gray-400 font-mono cursor-pointer hover:bg-gray-200" data-id="element-4635">
                    [Drone View]
                  </div>
                  <div data-testid="listing-detail-3d-view" className="flex-1 bg-gray-100 border-2 border-dashed border-gray-300 flex items-center justify-center text-xs text-gray-400 font-mono cursor-pointer hover:bg-gray-200" data-id="element-4636">
                    [3D View]
                  </div>
                </div>
              </div>
            </div>

            {/* Tabs Navigation */}
            <div data-testid="listing-detail-tabs" className="bg-white border border-gray-300 sticky top-[73px] z-10 shadow-sm overflow-x-auto" data-id="element-4637">
              <div className="flex min-w-max" data-id="element-4638">
                {tabs.map(tab => <button key={tab.id} data-testid={`listing-detail-tab-${tab.id}`} data-active={activeTab === tab.id} onClick={() => setActiveTab(tab.id)} className={`flex items-center gap-2 px-6 py-4 text-sm font-bold border-b-2 transition-colors ${activeTab === tab.id ? 'border-[#1f2933] text-[#1f2933] bg-gray-50' : 'border-transparent text-gray-500 hover:text-gray-800 hover:bg-gray-50'}`} data-id="element-4639">
                    <tab.icon className="w-4 h-4" data-id="element-4640" />
                    {tab.label}
                  </button>)}
              </div>
            </div>

            {/* Tab Content */}
            <div data-testid="listing-detail-tab-content" className="bg-white border border-gray-300 p-6 md:p-8 min-h-[400px]" data-id="element-4641">
              {/* OVERVIEW TAB */}
              {activeTab === 'overview' && <div data-testid="listing-detail-overview-content" className="space-y-8 animate-in fade-in" data-id="element-4642">
                  <div data-testid="listing-detail-overview-highlights" data-id="element-4643">
                    <h2 className="text-xl font-bold mb-6 pb-2 border-b border-gray-200" data-id="element-4644">
                      Key Highlights
                    </h2>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-4645">
                      {[{
                    label: 'Plot Area',
                    value: '2,400 Sq. Ft'
                  }, {
                    label: 'Dimensions',
                    value: '40 x 60 ft'
                  }, {
                    label: 'Facing',
                    value: 'North-East'
                  }, {
                    label: 'Road Width',
                    value: '12 Meters'
                  }, {
                    label: 'Zoning',
                    value: 'Residential (R-Zone)'
                  }, {
                    label: 'Ownership',
                    value: 'Freehold'
                  }, {
                    label: 'Boundary',
                    value: 'Fenced Wall'
                  }, {
                    label: 'Water',
                    value: 'Municipal + Borewell'
                  }].map((attr, i) => <div key={i} data-testid={`listing-detail-highlight-${i + 1}`} className="p-3 bg-gray-50 border border-gray-200" data-id="element-4646">
                          <dt className="text-xs font-mono text-gray-500 uppercase mb-1" data-id="element-4647">
                            {attr.label}
                          </dt>
                          <dd className="font-bold text-[#1f2933]" data-id="element-4648">
                            {attr.value}
                          </dd>
                        </div>)}
                    </div>
                  </div>

                  <div data-testid="listing-detail-overview-about" data-id="element-4649">
                    <h2 className="text-xl font-bold mb-4" data-id="element-4650">
                      About this Property
                    </h2>
                    <p className="text-gray-600 leading-relaxed mb-4" data-id="element-4651">
                      Excellent investment opportunity in the heart of Hinjewadi
                      IT Park. This corner plot is fully sanctioned with NA
                      order and clear title. Located just 500 meters from the
                      upcoming Metro station and 2km from Wipro Circle. Ideal
                      for constructing a bungalow or G+3 residential apartments.
                    </p>
                    <p className="text-gray-600 leading-relaxed" data-id="element-4652">
                      The plot has a 40ft wide road frontage and is surrounded
                      by developed societies. Electricity and water connections
                      are already available on site.
                    </p>
                  </div>

                  <div data-testid="listing-detail-overview-qa-preview" data-id="element-4653">
                    <h2 className="text-xl font-bold mb-4" data-id="element-4654">
                      Questions & Answers
                    </h2>
                    <div className="space-y-4" data-id="element-4655">
                      <div className="border border-dashed border-gray-200 p-4 bg-gray-50" data-id="element-4656">
                        <p className="font-bold text-sm mb-2" data-id="element-4657">
                          Q: Is the price negotiable?
                        </p>
                        <p className="text-sm text-gray-600" data-id="element-4658">
                          A: Slight negotiation is possible for immediate
                          closure. We are looking for a direct buyer.
                        </p>
                      </div>
                      <div className="border border-dashed border-gray-200 p-4 bg-gray-50" data-id="element-4659">
                        <p className="font-bold text-sm mb-2" data-id="element-4660">
                          Q: Is loan available?
                        </p>
                        <p className="text-sm text-gray-600" data-id="element-4661">
                          A: Yes, approved by SBI and HDFC.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>}

              {/* LOCATION TAB */}
              {activeTab === 'location' && <div data-testid="listing-detail-location-content" className="space-y-8 animate-in fade-in" data-id="element-4662">
                  <div data-testid="listing-detail-location-map" className="aspect-video bg-gray-100 border-2 border-dashed border-gray-300 flex items-center justify-center text-gray-400 font-mono" data-id="element-4663">
                    [Interactive Map Placeholder: Plot Boundary Overlay]
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-4664">
                    <div data-testid="listing-detail-location-address" data-id="element-4665">
                      <h3 className="font-bold text-lg mb-4" data-id="element-4666">
                        Address Details
                      </h3>
                      <div className="space-y-3" data-id="element-4667">
                        {[{
                      label: 'Survey No.',
                      value: '45/2/A'
                    }, {
                      label: 'CTS No.',
                      value: '1240'
                    }, {
                      label: 'Village',
                      value: 'Maan'
                    }, {
                      label: 'Taluka',
                      value: 'Mulshi'
                    }, {
                      label: 'PIN Code',
                      value: '411057'
                    }].map((item, i) => <div key={i} data-testid={`listing-detail-address-${i + 1}`} className="flex justify-between border-b border-gray-100 pb-2" data-id="element-4668">
                            <span className="text-sm text-gray-500" data-id="element-4669">
                              {item.label}
                            </span>
                            <span className="font-mono font-bold text-sm" data-id="element-4670">
                              {item.value}
                            </span>
                          </div>)}
                      </div>
                    </div>

                    <div data-testid="listing-detail-location-measurements" data-id="element-4671">
                      <h3 className="font-bold text-lg mb-4" data-id="element-4672">
                        Measurements & Boundary
                      </h3>
                      <div className="space-y-3" data-id="element-4673">
                        {[{
                      label: 'Plot Shape',
                      value: 'Regular (Rectangular)'
                    }, {
                      label: 'Frontage',
                      value: '40 ft'
                    }, {
                      label: 'Depth',
                      value: '60 ft'
                    }, {
                      label: 'Boundary Wall',
                      value: 'Present (6ft Height)',
                      color: 'green'
                    }, {
                      label: 'Corner Plot',
                      value: 'Yes (Two sides open)',
                      color: 'blue'
                    }].map((item, i) => <div key={i} data-testid={`listing-detail-measurement-${i + 1}`} className="flex justify-between border-b border-gray-100 pb-2" data-id="element-4674">
                            <span className="text-sm text-gray-500" data-id="element-4675">
                              {item.label}
                            </span>
                            <span className={`font-bold text-sm ${item.color === 'green' ? 'text-green-600' : item.color === 'blue' ? 'text-blue-600' : ''}`} data-id="element-4676">
                              {item.value}
                            </span>
                          </div>)}
                      </div>
                    </div>
                  </div>

                  <div data-testid="listing-detail-location-proximity" data-id="element-4677">
                    <h3 className="font-bold text-lg mb-4 flex items-center gap-2" data-id="element-4678">
                      <Calculator className="w-5 h-5" data-id="element-4679" /> Proximity Calculator
                    </h3>
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-4" data-id="element-4680">
                      {[{
                    place: 'Metro Station',
                    dist: '0.5 km',
                    time: '5 min walk'
                  }, {
                    place: 'Wipro Circle',
                    dist: '2.0 km',
                    time: '10 min drive'
                  }, {
                    place: 'Pune Airport',
                    dist: '22 km',
                    time: '45 min drive'
                  }, {
                    place: 'Symbiosis College',
                    dist: '3.5 km',
                    time: '15 min drive'
                  }, {
                    place: 'Ruby Hall Clinic',
                    dist: '1.8 km',
                    time: '8 min drive'
                  }, {
                    place: 'Xion Mall',
                    dist: '1.2 km',
                    time: '5 min drive'
                  }].map((item, i) => <div key={i} data-testid={`listing-detail-proximity-${i + 1}`} className="p-3 border border-gray-200 bg-gray-50" data-id="element-4681">
                          <div className="text-xs text-gray-500 uppercase mb-1" data-id="element-4682">
                            {item.place}
                          </div>
                          <div className="font-bold text-lg" data-id="element-4683">{item.dist}</div>
                          <div className="text-xs text-gray-400" data-id="element-4684">
                            {item.time}
                          </div>
                        </div>)}
                    </div>
                  </div>
                </div>}

              {/* LEGAL TAB */}
              {activeTab === 'legal' && <div data-testid="listing-detail-legal-content" className="space-y-8 animate-in fade-in" data-id="element-4685">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-4686">
                    <div data-testid="listing-detail-legal-ownership" data-id="element-4687">
                      <h3 className="font-bold text-lg mb-4" data-id="element-4688">
                        Ownership Details
                      </h3>
                      <div className="space-y-3" data-id="element-4689">
                        <div data-testid="listing-detail-ownership-type" className="flex justify-between border-b border-gray-100 pb-2" data-id="element-4690">
                          <span className="text-sm text-gray-500" data-id="element-4691">
                            Ownership Type
                          </span>
                          <span className="font-bold text-sm" data-id="element-4692">Freehold</span>
                        </div>
                        <div data-testid="listing-detail-seller-type" className="flex justify-between border-b border-gray-100 pb-2" data-id="element-4693">
                          <span className="text-sm text-gray-500" data-id="element-4694">
                            Seller Type
                          </span>
                          <span className="font-bold text-sm" data-id="element-4695">
                            Individual Owner
                          </span>
                        </div>
                        <div data-testid="listing-detail-title-status" className="flex justify-between border-b border-gray-100 pb-2" data-id="element-4696">
                          <span className="text-sm text-gray-500" data-id="element-4697">
                            Title Status
                          </span>
                          <span className="font-bold text-sm text-green-600" data-id="element-4698">
                            Clear & Marketable
                          </span>
                        </div>
                        <div data-testid="listing-detail-litigation" className="flex justify-between border-b border-gray-100 pb-2" data-id="element-4699">
                          <span className="text-sm text-gray-500" data-id="element-4700">
                            Litigation History
                          </span>
                          <span className="font-bold text-sm text-green-600" data-id="element-4701">
                            None (NIL Certificate)
                          </span>
                        </div>
                      </div>
                    </div>

                    <div data-testid="listing-detail-legal-risk" className="bg-gray-50 border border-gray-200 p-4" data-id="element-4702">
                      <h3 className="font-bold text-lg mb-4 flex items-center gap-2" data-id="element-4703">
                        <Shield className="w-5 h-5" data-id="element-4704" /> Risk Assessment
                      </h3>
                      <div className="space-y-4" data-id="element-4705">
                        <div data-testid="listing-detail-risk-score" data-id="element-4706">
                          <div className="flex justify-between text-sm mb-1" data-id="element-4707">
                            <span data-id="element-4708">Overall Risk Score</span>
                            <span className="font-bold text-green-600" data-id="element-4709">
                              Low Risk
                            </span>
                          </div>
                          <div className="h-2 bg-gray-200 rounded-full overflow-hidden" data-id="element-4710">
                            <div className="h-full bg-green-500 w-[90%]" data-id="element-4711"></div>
                          </div>
                        </div>
                        <div data-testid="listing-detail-risk-breakdown" className="grid grid-cols-3 gap-2 text-center text-xs" data-id="element-4712">
                          <div data-testid="listing-detail-risk-legal" className="p-2 bg-white border border-gray-200" data-id="element-4713">
                            <div className="font-bold text-green-600" data-id="element-4714">9/10</div>
                            <div className="text-gray-500" data-id="element-4715">Legal</div>
                          </div>
                          <div data-testid="listing-detail-risk-title" className="p-2 bg-white border border-gray-200" data-id="element-4716">
                            <div className="font-bold text-green-600" data-id="element-4717">
                              10/10
                            </div>
                            <div className="text-gray-500" data-id="element-4718">Title</div>
                          </div>
                          <div data-testid="listing-detail-risk-compliance" className="p-2 bg-white border border-gray-200" data-id="element-4719">
                            <div className="font-bold text-yellow-600" data-id="element-4720">
                              8/10
                            </div>
                            <div className="text-gray-500" data-id="element-4721">Compliance</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div data-testid="listing-detail-legal-checklist" data-id="element-4722">
                    <h3 className="font-bold text-lg mb-4" data-id="element-4723">
                      Document Checklist
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-4724">
                      {[{
                    cat: 'Ownership Proof',
                    items: ['Sale Deed', '7/12 Extract', 'Mutation Entry'],
                    status: 'verified'
                  }, {
                    cat: 'Approvals',
                    items: ['NA Order', 'Layout Plan', 'Zone Certificate'],
                    status: 'verified'
                  }, {
                    cat: 'Legal Clearances',
                    items: ['Encumbrance Cert (30 yrs)', 'Search Report', 'Public Notice'],
                    status: 'verified'
                  }, {
                    cat: 'Survey Docs',
                    items: ['Demarcation Map', 'Mojani Sketch'],
                    status: 'pending'
                  }].map((group, i) => <div key={i} data-testid={`listing-detail-doc-group-${i + 1}`} className="border border-gray-200 p-4" data-id="element-4725">
                          <div className="flex justify-between items-center mb-3" data-id="element-4726">
                            <h4 className="font-bold text-sm" data-id="element-4727">{group.cat}</h4>
                            {group.status === 'verified' ? <span data-testid={`listing-detail-doc-group-${i + 1}-status`} className="text-xs font-bold text-green-600 flex items-center gap-1" data-id="element-4728">
                                <CheckCircle className="w-3 h-3" data-id="element-4729" /> Verified
                              </span> : <span data-testid={`listing-detail-doc-group-${i + 1}-status`} className="text-xs font-bold text-yellow-600 flex items-center gap-1" data-id="element-4730">
                                <Clock className="w-3 h-3" data-id="element-4731" /> Pending
                              </span>}
                          </div>
                          <ul className="space-y-1" data-id="element-4732">
                            {group.items.map((item, j) => <li key={j} className="text-xs text-gray-600 flex items-center gap-2" data-id="element-4733">
                                <span className="w-1.5 h-1.5 bg-gray-300 rounded-full" data-id="element-4734"></span>{' '}
                                {item}
                              </li>)}
                          </ul>
                        </div>)}
                    </div>
                  </div>
                </div>}

              {/* INFRASTRUCTURE TAB */}
              {activeTab === 'infra' && <div data-testid="listing-detail-infra-content" className="space-y-8 animate-in fade-in" data-id="element-4735">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-4736">
                    <div data-testid="listing-detail-infra-road" data-id="element-4737">
                      <h3 className="font-bold text-lg mb-4" data-id="element-4738">Road & Access</h3>
                      <div className="space-y-3" data-id="element-4739">
                        {[{
                      label: 'Road Ownership',
                      value: 'Municipal Corporation'
                    }, {
                      label: 'Road Surface',
                      value: 'Concrete'
                    }, {
                      label: 'Road Width',
                      value: '12 Meters (40 ft)'
                    }, {
                      label: 'All-weather Access',
                      value: 'Yes',
                      color: 'green'
                    }].map((item, i) => <div key={i} data-testid={`listing-detail-road-${i + 1}`} className="flex justify-between border-b border-gray-100 pb-2" data-id="element-4740">
                            <span className="text-sm text-gray-500" data-id="element-4741">
                              {item.label}
                            </span>
                            <span className={`font-bold text-sm ${item.color === 'green' ? 'text-green-600' : ''}`} data-id="element-4742">
                              {item.value}
                            </span>
                          </div>)}
                      </div>
                    </div>

                    <div data-testid="listing-detail-infra-utilities" data-id="element-4743">
                      <h3 className="font-bold text-lg mb-4" data-id="element-4744">Utilities Grid</h3>
                      <div className="grid grid-cols-2 gap-4" data-id="element-4745">
                        {[{
                      icon: 'electricity',
                      name: 'Electricity',
                      status: 'Available at site',
                      provider: 'MSEDCL Grid'
                    }, {
                      icon: 'water',
                      name: 'Water',
                      status: 'Municipal + Borewell',
                      provider: 'Potable Quality'
                    }, {
                      icon: 'sewerage',
                      name: 'Sewerage',
                      status: 'Underground Line',
                      provider: 'Connected to Main'
                    }, {
                      icon: 'connectivity',
                      name: 'Connectivity',
                      status: 'Fiber Available',
                      provider: 'Jio / Airtel'
                    }].map((util, i) => <div key={i} data-testid={`listing-detail-utility-${i + 1}`} className="p-3 border border-gray-200 bg-gray-50" data-id="element-4746">
                            <div className="flex items-center gap-2 mb-1" data-id="element-4747">
                              {util.icon === 'electricity' && <Zap className="w-4 h-4 text-yellow-600" data-id="element-4748" />}
                              {util.icon === 'water' && <div className="w-4 h-4 text-blue-600 font-bold text-center leading-none" data-id="element-4749">
                                  W
                                </div>}
                              {util.icon === 'sewerage' && <div className="w-4 h-4 text-green-600 font-bold text-center leading-none" data-id="element-4750">
                                  S
                                </div>}
                              {util.icon === 'connectivity' && <div className="w-4 h-4 text-purple-600 font-bold text-center leading-none" data-id="element-4751">
                                  N
                                </div>}
                              <span className="font-bold text-sm" data-id="element-4752">
                                {util.name}
                              </span>
                            </div>
                            <div className="text-xs text-gray-600" data-id="element-4753">
                              {util.status}
                            </div>
                            <div className="text-[10px] text-gray-400" data-id="element-4754">
                              {util.provider}
                            </div>
                          </div>)}
                      </div>
                    </div>
                  </div>

                  <div data-testid="listing-detail-infra-amenities" data-id="element-4755">
                    <h3 className="font-bold text-lg mb-4" data-id="element-4756">
                      Community Amenities
                    </h3>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-4757">
                      {['Street Lights', 'CCTV Surveillance', 'Security Gate', 'Waste Collection', 'Paved Footpaths', 'Storm Water Drain'].map((item, i) => <div key={i} data-testid={`listing-detail-amenity-${i + 1}`} className="flex items-center gap-2 p-2 border border-dashed border-gray-200" data-id="element-4758">
                          <CheckCircle className="w-4 h-4 text-green-500" data-id="element-4759" />
                          <span className="text-sm text-gray-700" data-id="element-4760">{item}</span>
                        </div>)}
                    </div>
                  </div>
                </div>}

              {/* ZONING TAB */}
              {activeTab === 'zoning' && <div data-testid="listing-detail-zoning-content" className="space-y-8 animate-in fade-in" data-id="element-4761">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-4762">
                    <div data-testid="listing-detail-zoning-landuse" data-id="element-4763">
                      <h3 className="font-bold text-lg mb-4" data-id="element-4764">
                        Land Use & Zoning
                      </h3>
                      <div className="space-y-3" data-id="element-4765">
                        {[{
                      label: 'Current Land Use',
                      value: 'Residential'
                    }, {
                      label: 'Zoning Classification',
                      value: 'R-1 (Pure Residential)'
                    }, {
                      label: 'Master Plan',
                      value: 'Pune DP 2027'
                    }, {
                      label: 'Development Status',
                      value: 'Approved Layout'
                    }].map((item, i) => <div key={i} data-testid={`listing-detail-landuse-${i + 1}`} className="flex justify-between border-b border-gray-100 pb-2" data-id="element-4766">
                            <span className="text-sm text-gray-500" data-id="element-4767">
                              {item.label}
                            </span>
                            <span className="font-bold text-sm" data-id="element-4768">
                              {item.value}
                            </span>
                          </div>)}
                      </div>
                    </div>

                    <div data-testid="listing-detail-zoning-regulations" data-id="element-4769">
                      <h3 className="font-bold text-lg mb-4" data-id="element-4770">
                        Building Regulations
                      </h3>
                      <div className="space-y-3" data-id="element-4771">
                        {[{
                      label: 'FSI / FAR',
                      value: '1.5 (Expandable to 2.0)'
                    }, {
                      label: 'Ground Coverage',
                      value: 'Max 40%'
                    }, {
                      label: 'Height Restriction',
                      value: '15 Meters (G+3)'
                    }, {
                      label: 'Setbacks',
                      value: 'Front: 3m, Side: 1.5m'
                    }].map((item, i) => <div key={i} data-testid={`listing-detail-regulation-${i + 1}`} className="flex justify-between border-b border-gray-100 pb-2" data-id="element-4772">
                            <span className="text-sm text-gray-500" data-id="element-4773">
                              {item.label}
                            </span>
                            <span className="font-mono font-bold text-sm" data-id="element-4774">
                              {item.value}
                            </span>
                          </div>)}
                      </div>
                    </div>
                  </div>

                  <div data-testid="listing-detail-zoning-environmental" className="bg-yellow-50 border border-yellow-200 p-4" data-id="element-4775">
                    <h3 className="font-bold text-lg mb-4 flex items-center gap-2 text-yellow-900" data-id="element-4776">
                      <AlertTriangle className="w-5 h-5" data-id="element-4777" /> Environmental
                      Constraints
                    </h3>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-4778">
                      {[{
                    label: 'CRZ Zone',
                    val: 'No',
                    safe: true
                  }, {
                    label: 'Flood Zone',
                    val: 'No',
                    safe: true
                  }, {
                    label: 'High Tension Line',
                    val: 'None',
                    safe: true
                  }, {
                    label: 'Water Body',
                    val: '> 500m',
                    safe: true
                  }].map((item, i) => <div key={i} data-testid={`listing-detail-env-${i + 1}`} className="bg-white p-3 border border-yellow-100" data-id="element-4779">
                          <div className="text-xs text-gray-500 uppercase mb-1" data-id="element-4780">
                            {item.label}
                          </div>
                          <div className={`font-bold ${item.safe ? 'text-green-600' : 'text-red-600'}`} data-id="element-4781">
                            {item.val}
                          </div>
                        </div>)}
                    </div>
                  </div>
                </div>}

              {/* FINANCIALS TAB */}
              {activeTab === 'financials' && <div data-testid="listing-detail-financials-content" className="space-y-8 animate-in fade-in" data-id="element-4782">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-4783">
                    <div data-testid="listing-detail-financials-price" data-id="element-4784">
                      <h3 className="font-bold text-lg mb-4" data-id="element-4785">
                        Price Breakdown
                      </h3>
                      <div className="bg-gray-50 border border-gray-200 p-4 space-y-3" data-id="element-4786">
                        <div data-testid="listing-detail-asking-price" className="flex justify-between items-center" data-id="element-4787">
                          <span className="text-sm text-gray-600" data-id="element-4788">
                            Asking Price
                          </span>
                          <span className="font-bold text-lg" data-id="element-4789">₹ 45,00,000</span>
                        </div>
                        <div data-testid="listing-detail-price-sqft" className="flex justify-between items-center text-sm" data-id="element-4790">
                          <span className="text-gray-500" data-id="element-4791">
                            Price per Sq. Ft
                          </span>
                          <span className="font-mono" data-id="element-4792">₹ 1,875</span>
                        </div>
                        <div data-testid="listing-detail-guideline-value" className="flex justify-between items-center text-sm" data-id="element-4793">
                          <span className="text-gray-500" data-id="element-4794">
                            Govt. Guideline Value
                          </span>
                          <span className="font-mono" data-id="element-4795">₹ 1,650 / sq.ft</span>
                        </div>
                        <div data-testid="listing-detail-premium" className="flex justify-between items-center text-sm pt-2 border-t border-gray-200" data-id="element-4796">
                          <span className="text-gray-500" data-id="element-4797">
                            Premium over Guideline
                          </span>
                          <span className="font-bold text-blue-600" data-id="element-4798">
                            +13.6%
                          </span>
                        </div>
                      </div>
                    </div>

                    <div data-testid="listing-detail-financials-costs" data-id="element-4799">
                      <h3 className="font-bold text-lg mb-4" data-id="element-4800">
                        Estimated Additional Costs
                      </h3>
                      <div className="space-y-3" data-id="element-4801">
                        {[{
                      label: 'Stamp Duty (6%)',
                      value: '₹ 2,70,000'
                    }, {
                      label: 'Registration (1%)',
                      value: '₹ 45,000'
                    }, {
                      label: 'Development Charges',
                      value: '₹ 50,000'
                    }].map((item, i) => <div key={i} data-testid={`listing-detail-cost-${i + 1}`} className="flex justify-between border-b border-gray-100 pb-2" data-id="element-4802">
                            <span className="text-sm text-gray-500" data-id="element-4803">
                              {item.label}
                            </span>
                            <span className="font-mono font-bold text-sm" data-id="element-4804">
                              {item.value}
                            </span>
                          </div>)}
                        <div data-testid="listing-detail-total-cost" className="flex justify-between pt-2" data-id="element-4805">
                          <span className="font-bold text-sm" data-id="element-4806">
                            Total Estimated Cost
                          </span>
                          <span className="font-mono font-bold text-lg" data-id="element-4807">
                            ₹ 48,65,000
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div data-testid="listing-detail-financials-market" data-id="element-4808">
                    <h3 className="font-bold text-lg mb-4" data-id="element-4809">
                      Market Intelligence
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6" data-id="element-4810">
                      <div data-testid="listing-detail-appreciation-3yr" className="p-4 border border-green-200 bg-green-50" data-id="element-4811">
                        <div className="text-xs text-green-800 uppercase mb-1" data-id="element-4812">
                          3-Year Appreciation
                        </div>
                        <div className="text-2xl font-bold text-green-700" data-id="element-4813">
                          +28%
                        </div>
                        <div className="text-xs text-green-600" data-id="element-4814">
                          Avg. in Hinjewadi
                        </div>
                      </div>
                      <div data-testid="listing-detail-appreciation-5yr" className="p-4 border border-green-200 bg-green-50" data-id="element-4815">
                        <div className="text-xs text-green-800 uppercase mb-1" data-id="element-4816">
                          5-Year Appreciation
                        </div>
                        <div className="text-2xl font-bold text-green-700" data-id="element-4817">
                          +45%
                        </div>
                        <div className="text-xs text-green-600" data-id="element-4818">
                          Consistent Growth
                        </div>
                      </div>
                      <div data-testid="listing-detail-loan-eligibility" className="p-4 border border-blue-200 bg-blue-50" data-id="element-4819">
                        <div className="text-xs text-blue-800 uppercase mb-1" data-id="element-4820">
                          Loan Eligibility
                        </div>
                        <div className="text-2xl font-bold text-blue-700" data-id="element-4821">
                          70% LTV
                        </div>
                        <div className="text-xs text-blue-600" data-id="element-4822">
                          Approved by SBI, HDFC
                        </div>
                      </div>
                    </div>

                    <div data-testid="listing-detail-price-history" className="h-48 bg-gray-50 border-2 border-dashed border-gray-200 flex items-center justify-center text-gray-400 font-mono" data-id="element-4823">
                      [Price History Line Graph Placeholder]
                    </div>
                  </div>
                </div>}

              {/* DOCUMENTS TAB */}
              {activeTab === 'documents' && <div data-testid="listing-detail-documents-content" className="space-y-6 animate-in fade-in" data-id="element-4824">
                  <div className="flex justify-between items-center mb-4" data-id="element-4825">
                    <h2 className="text-xl font-bold" data-id="element-4826">Property Documents</h2>
                    <button data-testid="listing-detail-download-all-btn" onClick={handleDownloadAll} className="flex items-center gap-2 px-4 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-4827">
                      <Download className="w-4 h-4" data-id="element-4828" /> Download All
                    </button>
                  </div>

                  <DocumentSection documents={[{
                name: '7/12 Extract (Satbara)',
                status: 'verified',
                date: 'Oct 12, 2023'
              }, {
                name: 'NA Order Copy',
                status: 'verified',
                date: 'Oct 10, 2023'
              }, {
                name: 'Title Search Report (30 Years)',
                status: 'verified',
                date: 'Sep 28, 2023'
              }, {
                name: 'Sale Deed (Previous)',
                status: 'verified',
                date: '2015'
              }, {
                name: 'Mutation Entry (Ferfar)',
                status: 'verified',
                date: '2015'
              }, {
                name: 'Zone Certificate',
                status: 'pending',
                date: 'Nov 01, 2023'
              }, {
                name: 'Demarcation Map',
                status: 'missing'
              }, {
                name: 'Property Tax Receipt',
                status: 'verified',
                date: '2023-24'
              }, {
                name: 'Layout Approval Letter',
                status: 'verified',
                date: '2018'
              }, {
                name: 'NOC from Society',
                status: 'verified',
                date: 'Oct 2023'
              }]} data-id="element-4829" />
                </div>}

              {/* REVIEWS TAB */}
              {activeTab === 'reviews' && <div data-testid="listing-detail-reviews-content" className="animate-in fade-in" data-id="element-4830">
                  <ReviewsSection listingId={id || '1'} listingTitle={listingTitle} overallRating={4.7} totalReviews={mockReviews.length} reviews={mockReviews} data-id="element-4831" />
                </div>}

              {/* Q&A TAB */}
              {activeTab === 'qa' && <div data-testid="listing-detail-qa-content" className="animate-in fade-in" data-id="element-4832">
                  <QASection listingTitle={listingTitle} questions={mockQuestions} data-id="element-4833" />
                </div>}
            </div>
          </div>

          {/* Sidebar Column */}
          <div className="lg:col-span-4 space-y-6" data-id="element-4834">
            {/* Seller Card */}
            <div data-testid="listing-detail-seller-card" className="bg-white border border-gray-300 p-6 sticky top-24" data-id="element-4835">
              <h3 className="text-sm font-mono font-bold text-gray-500 uppercase mb-4" data-id="element-4836">
                Seller Information
              </h3>
              <div className="flex items-center gap-4 mb-6" data-id="element-4837">
                <div className="w-12 h-12 bg-gray-200 rounded-full flex items-center justify-center" data-id="element-4838">
                  <User className="w-6 h-6 text-gray-500" data-id="element-4839" />
                </div>
                <div data-id="element-4840">
                  <Link data-testid="listing-detail-seller-name" to="/seller/profile/1" className="font-bold text-lg text-[#1f2933] hover:underline" data-id="element-4841">
                    {sellerName}
                  </Link>
                  <p data-testid="listing-detail-seller-type" className="text-sm text-gray-500" data-id="element-4842">
                    Individual Owner
                  </p>
                </div>
              </div>

              <div data-testid="listing-detail-seller-stats" className="grid grid-cols-2 gap-4 mb-6 border-t border-b border-dashed border-gray-200 py-4" data-id="element-4843">
                <div className="text-center" data-id="element-4844">
                  <p data-testid="listing-detail-seller-rating" className="font-bold text-xl text-[#1f2933]" data-id="element-4845">
                    4.8
                  </p>
                  <p className="text-xs text-gray-500 font-mono" data-id="element-4846">Rating</p>
                </div>
                <div className="text-center border-l border-dashed border-gray-200" data-id="element-4847">
                  <p data-testid="listing-detail-seller-verified" className="font-bold text-xl text-[#1f2933]" data-id="element-4848">
                    Verified
                  </p>
                  <p className="text-xs text-gray-500 font-mono" data-id="element-4849">Identity</p>
                </div>
              </div>

              <button data-testid="listing-detail-contact-seller-btn" onClick={() => setIsContactOpen(true)} className="w-full py-3 bg-[#1f2933] text-white font-bold mb-3 hover:bg-gray-800 transition-colors" data-id="element-4850">
                Contact Seller
              </button>
              <button data-testid="listing-detail-schedule-visit-btn" onClick={() => setIsScheduleOpen(true)} className="w-full py-3 border border-[#1f2933] text-[#1f2933] font-bold hover:bg-gray-50 transition-colors" data-id="element-4851">
                Schedule Site Visit
              </button>

              <div data-testid="listing-detail-seller-protection" className="mt-6 p-4 bg-gray-50 border border-dashed border-gray-300 text-xs text-gray-500" data-id="element-4852">
                <div className="flex items-start gap-2" data-id="element-4853">
                  <Shield className="w-4 h-4 shrink-0 mt-0.5" data-id="element-4854" />
                  <p data-id="element-4855">
                    Citiplots protects your contact info. Chat directly through
                    our secure platform.
                  </p>
                </div>
              </div>
            </div>

            {/* Safety Tips */}
            <div data-testid="listing-detail-safety-tips" className="bg-white border border-gray-300 p-6" data-id="element-4856">
              <h3 className="text-sm font-mono font-bold text-gray-500 uppercase mb-4" data-id="element-4857">
                Transaction Safety
              </h3>
              <ul className="space-y-3 text-sm text-gray-600" data-id="element-4858">
                <li className="flex gap-2" data-id="element-4859">
                  <span className="text-green-600 font-bold" data-id="element-4860">✓</span> Never
                  transfer money before verification.
                </li>
                <li className="flex gap-2" data-id="element-4861">
                  <span className="text-green-600 font-bold" data-id="element-4862">✓</span> Always
                  inspect the plot physically.
                </li>
                <li className="flex gap-2" data-id="element-4863">
                  <span className="text-green-600 font-bold" data-id="element-4864">✓</span> Use
                  Citiplots Escrow for token amounts.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-4865" />

      <ContactSellerModal isOpen={isContactOpen} onClose={() => setIsContactOpen(false)} sellerName={sellerName} listingTitle={listingTitle} data-id="element-4866" />
      <ScheduleVisitModal isOpen={isScheduleOpen} onClose={() => setIsScheduleOpen(false)} data-id="element-4867" />
      <MessageModal isOpen={isMessageModalOpen} onClose={() => setIsMessageModalOpen(false)} title="Downloading Documents" message="Preparing document package... In production, this would create a ZIP file with all verified documents." type="success" data-id="element-4868" />
    </div>;
}